<div class="activate-container safe-area-inset-top safe-area-inset-bottom">
  <div class="container-fluid">
    <div class="card activate-card">
      <div class="card-header">
        <h2>Activar Cuenta</h2>
      </div>

      <div class="card-body">
        @if (!tokenValid) {
          <div class="error-banner">
            <p>{{ error }}</p>
            <a routerLink="/register" class="btn btn-primary btn-block">Volver al registro</a>
          </div>
        } @else {
          <p class="activate-info">Crea tu contrasena para activar tu cuenta</p>

          <form [formGroup]="activateForm" (ngSubmit)="onSubmit()" class="activate-form">
            <div class="form-group">
              <label for="password">Contrasena</label>
              <input
                type="password"
                id="password"
                formControlName="password"
                class="form-control"
                [class.is-invalid]="f['password'].invalid && f['password'].touched"
                placeholder="Minimo 6 caracteres"
              >
              @if (f['password'].invalid && f['password'].touched) {
                <div class="error-message">
                  @if (f['password'].errors?.['required']) {
                    <span>Contrasena es requerida</span>
                  }
                  @if (f['password'].errors?.['minlength']) {
                    <span>Contrasena debe tener al menos 6 caracteres</span>
                  }
                </div>
              }
            </div>

            <div class="form-group">
              <label for="confirmPassword">Confirmar Contrasena</label>
              <input
                type="password"
                id="confirmPassword"
                formControlName="confirmPassword"
                class="form-control"
                [class.is-invalid]="f['confirmPassword'].invalid && f['confirmPassword'].touched"
                placeholder="Repetir contrasena"
              >
              @if (f['confirmPassword'].invalid && f['confirmPassword'].touched) {
                <div class="error-message">
                  @if (f['confirmPassword'].errors?.['required']) {
                    <span>Confirmacion es requerida</span>
                  }
                  @if (f['confirmPassword'].errors?.['passwordMismatch']) {
                    <span>Las contrasenas no coinciden</span>
                  }
                </div>
              }
            </div>

            <div class="password-requirements">
              <p>La contrasena debe incluir:</p>
              <ul>
                <li>Al menos 6 caracteres</li>
                <li>Una mayuscula y una minuscula</li>
                <li>Un numero</li>
                <li>Un caracter especial (!&#64;#$%...)</li>
              </ul>
            </div>

            @if (error) {
              <div class="error-message global-error">
                {{ error }}
              </div>
            }

            <button
              type="submit"
              class="btn btn-primary btn-block btn-lg"
              [disabled]="loading || activateForm.invalid"
            >
              @if (loading) {
                <span>Activando...</span>
              } @else {
                <span>Activar Cuenta</span>
              }
            </button>
          </form>
        }
      </div>

      <div class="card-footer">
        <div class="login-link">
          <p>Ya tienes cuenta activa? <a routerLink="/login" class="login-link-text">Inicia sesion</a></p>
        </div>
      </div>
    </div>
  </div>
</div>
